import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Button, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';
import RenderTextFieldReduxMin from '../Complements/RenderTextFieldReduxMin';

import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';

import Alert from '@material-ui/lab/Alert';

const useStyles = () => ({
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
});

const validate = values => {
    const error = {}

    if (!values.amountdaily) {
        error.amountdaily = "El monto diario es obligatorio."
    }
    // if (/^([0-9])*$/.test(values.amountdaily) === false) {
    //     error.amountdaily = "El campo debe tener solamente números."
    // }
    if (/^[0-9]+([.][0-9]{0,2})?$/.test(values.amountdaily) === false) {
        error.amountdaily = "El campo debe tener 2 decimales. Ej: 4999.99"
    }
    if (!values.amountmonthly) {
        error.amountmonthly = "El monto mensual es obligatorio."
    }
    if (/^([0-9])*$/.test(values.amountmonthly) === false) {
        error.amountmonthly = "El campo debe tener solamente números."
    }
    return error
}


class ChangeQuotasForm extends Component {
    render() {
        const { classes, handleSubmit, valid, submitting, amountDaily } = this.props;
        return (
            <React.Fragment>
                <div style={{
                    padding: "20px",
                    border: '2px solid #BEBCC0',
                    
                    borderRadius: "8px",
                    // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
                }}>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <Typography>
                                    Define el monto máximo diario para transacciones. El valor no puede ser mayor a $ { amountDaily }.
                                </Typography>
                                {/* <Alert severity="info">Monto M&aacute;ximo de transferencias al d&iacute;a</Alert> */}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Field
                                    withFocus
                                    name="amountdaily"
                                    id="amountdaily"
                                    required
                                    allowZero={true}
                                    className={clsx(classes.margin, classes.textField)}
                                    component={RenderTextFieldReduxMin}
                                    autoComplete="off"
                                    label="Monto Diario"
                                    type="number"
                                    fullWidth
                                />
                                <Alert severity="info">Monto M&aacute;ximo de transferencias al d&iacute;a</Alert>
                            </Grid>
                            {/* <Grid item xs={12} md={12}>
                                <Field
                                    withFocus
                                    name="amountmonthly"
                                    id="amountmonthly"
                                    required
                                    allowZero={true}
                                    className={clsx(classes.margin, classes.textField)}
                                    autoComplete="off"
                                    component={RenderTextFieldReduxMin}
                                    label="Monto Mensual"
                                    type="text"
                                    fullWidth
                                    alert="jxos"
                                />
                                <Alert severity="info">Monto M&aacute;ximo de transferencias al mes</Alert>
                            </Grid> */}
                            <Grid item xs={6} md={6} lg={6}>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    disabled={!valid || submitting}
                                    size={"large"}
                                    className={classes.buttonStandard}
                                >
                                    Actualizar
                                </Button>
                            </Grid>



                        </Grid>
                    </form>
                </div>
            </React.Fragment>
        );
    }
}

const ChangeQuotasFormRedux = reduxForm(
    {
        form: 'ChangeQuotasForm',
        validate
    }
)(ChangeQuotasForm)

// export default ChangePasswordForm;
export default setPropsAsInitial(withStyles(useStyles)(ChangeQuotasFormRedux));

